if (!customElements.get('hoculus-share-icon')) {
    class HoculusShareIcon extends HTMLElement {
        constructor() {
            super();
            this.shareData = {
                title: "Messo a nuovo",
                text: this.dataset.message,
                url: this.dataset.url,
            };
            this.modalId = this.dataset.modalId;
        }

        connectedCallback() {
            this.addEventListener('click', ()=> {
                this.openShareModal();
            })
        }

        openShareModal() {
            if (navigator.share) {
                navigator.share(this.shareData);
            } else {
                // If not available, open the custom share modal
                window.location.hash = this.modalId;
            }
        }
    }
    customElements.define("hoculus-share-icon", HoculusShareIcon);
}